

import {defineComponent, PropType, inject} from "vue";
import {
    ConstructionWorkDetailCardMapInterface,
    IncidentDetailCardMapIncident
} from "modules/construction-work/src/Common/interface";
import { Store } from "modules/construction-work/src/Store";

export default defineComponent({
    name: "ItemDetailWork",
    props: {
        work: {
            type: Object as PropType<(IncidentDetailCardMapIncident|ConstructionWorkDetailCardMapInterface)>
        }
    },
    methods: {
        getStringPhones(phones: any[]): string {
            return 'тел.: ' + phones.map(item =>
                item.number + (item.comment ? ' ' + item.comment : '')
            ).join(', ');
        }
    },
    computed: {
        statuses() {
            return this.store?.initData?.statuses || {};
        },
        categories() {
            return this.store?.initData?.categories || {};
        },
        groupsIncidents() {
            return this.store?.initData?.groups || {};
        },
    },
    setup() {
        const store = inject<Store>("store");
        return {
            store,
        };
    },
})
